module.exports = __webpack_public_path__ + "img/stamp-fruit-roots-cherry.54b18c7a.png";